<template>
  <div class="windowDiv">
    <div class="uploadDiv">
      <div class="block">
        <el-cascader v-model="targetFolder" :options="options" placeholder="请选择所属目录" :show-all-levels="false"></el-cascader>
      </div>
      <el-upload
          class="upload-demo"
          :file-list="fileList"
          drag
          :limit="limit"
          accept=".pdf"
          :action="uploadUrl"
          :headers="uploadHeaders"
          multiple
          :on-success="handleUploadSuccess"
          :on-error="onError"
          :on-exceed="onExceed"
          :on-remove="handleRemove"
      >
        <el-icon class="uploadIcon"><el-icon-upload-filled/></el-icon>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <template #tip>
          <div class="el-upload__tip">只能上传PDF文件。</div>
        </template>
      </el-upload>
      <el-button type="primary" :loading="loading" class="button" @click="uploadFile">确认上传</el-button>
      <div class="textDiv">{{text}}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "UploadFile",
  data() {
    return {
      text: "",
      targetFolder: '',
      fileList: [],
      uploadUrl: '',
      uploadHeaders: {},
      options: [],
      url: '/frame/file/upload',
      limit: 1,
      uploadStatus: false,
      loading: false
    }
  },
  methods:{
    openPage(data){
      let windowObj = {}
      windowObj.icon = "system/upload";
      windowObj.component = "bus/UploadFileConfirm";
      windowObj.name = "文档上传确认";
      windowObj.parentData = data;
      windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.max = true

      this.$store.dispatch('core/openWindow', windowObj)
    },

    async uploadFile() {
      this.loading = true
      let data = {};
      data.folderId = this.targetFolder[this.targetFolder.length-1]
      data.fileId = this.fileList[0].response.data.id
      this.uploadStatus = true
      let {data: res} = await this.$axios.post('bus/fileStorage/addFileStorage', data,{timeout: 180000});
      this.loading = false
      this.uploadStatus = false
      if (res.code !== 0) {
        this.$message.error('上传失败：' + res.message)
        return;
      }
      this.$message.success('文件上传成功')
      this.text = "所有页面已全部处理完成。"
      data.fileList = res.data
      this.openPage(data)
    },

    onError() {
      this.$message.error('网络异常，上传请求发送失败')
    },

    onExceed(){
      this.$message.error('最多同时上传'+this.limit+"个文件。")
    },

    handleRemove() {
      this.onChange();
    },

    onChange() {
      let idList = this.fileList.map(item => item?.response?.data?.id || item.id);
      this.$emit('fileChange', idList)
    },

    handleUploadSuccess() {
      this.onChange();
    },

    async getUploadProgress() {
      if (this.uploadStatus){
        let {data: res} = await this.$axios.post('bus/fileStorage/getUploadProgress', {fileId:this.fileList[0].response.data.id});
        if (res.data.finished !== 0){
          res.data.finished++
          this.text = "共"+res.data.total+"页，正在处理第"+res.data.finished+"页，请稍后......"
        }else {
          this.text = "正在处理第1页，请稍后......"
        }
      }
    }

  },
  mounted() {
    this.timer = setInterval(this.getUploadProgress, 1000);
  },
  async created() {
    //重要设置
    this.uploadUrl = process.env.VUE_APP_AXIOS_BASE_URL + this.url;
    this.uploadHeaders = {token: localStorage.getItem('token')}

    let {data: res} = await this.$axios.get('/bus/folder/getFolderAll');
    if (res.code !== 0) {
      this.$message.error('获取文件列表失败');
    } else {
      this.options = res.data
    }
  }
}
</script>

<style scoped>
.windowDiv{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin : auto;
}
.uploadDiv{
  width: 895px;
  height: 100%;
  padding-top: 30px;
  position: absolute;
  left: 0;
  right: 0;
  margin : auto;
}
.uploadIcon{
  font-size: 100px;
  margin-top: 70px;
}
.upload-demo{
  width: 600px;
  height: 300px;
  position: absolute;
  left: 0;
  top: 90px;
  right: 0;
  margin : auto;
}
.block{
  width: 500px;
  height: 100px;
  position: absolute;
  left: -100px;
  right: 0;
  margin : auto;
}
.button{
  width: 100px;
  height: 40px;
  position: absolute;
  left: 0;
  top: 460px;
  right: 0;
  margin : auto;
}
.textDiv{
  width: 300px;
  height: 20px;
  position: absolute;
  left: 440px;
  top: 470px;
  right: 0;
  margin : auto;
}
.upload-demo ::v-deep(.el-upload-dragger){
  width: 590px !important;
  height: 290px !important;
}
</style>
